module.exports = __webpack_public_path__ + "img/MTRM[GYRI]-icon.6a6693f.png";